import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const uploadGorgiasNativeMacros = {
  name: "uploadGorgiasNativeMacros" as const,
  input: z.object({
    teamId: zExt.objectId(),
    fileName: z.string(),
    fileContent: z.string(),
    mimeType: z.string(),
  }),
  output: z.object({ importedCount: z.number(), skippedCount: z.number() }),
};
